export default [
  {
    path: '/se/about', // 关于我们
    name: 'seAbout',
    component: () => import('@/view/app-special-edition/about')
  },
  {
    path: '/se/contact', // 联系我们
    name: 'seContact',
    component: () => import('@/view/app-special-edition/contact')
  },
  {
    path: '/se/signout/auth', // 注销-验证
    name: 'seSignoutAuth',
    component: () => import('@/view/app-special-edition/signout/auth')
  },
  {
    path: '/se/signout/risk-notice', // 注销
    name: 'seSignoutRiskNotice',
    component: () => import('@/view/app-special-edition/signout/risk-notice')
  },
  {
    path: '/se/feedback', // 反馈评价
    name: 'seFeddback',
    component: () => import('@/view/app-special-edition/feedback')
  },
  {
    path: '/se/newPerson', // 新人
    name: 'seNewPerson',
    component: () => import('@/view/app-special-edition/newPerson')
  },
  {
    path: '/se/faq', // qa
    name: 'seFaq',
    component: () => import('@/view/app-special-edition/faq')
  }
]